import {Injectable} from '@angular/core';
import {Libraries, Loader, LoaderStatus} from "@googlemaps/js-api-loader"
import {ReplaySubject} from "rxjs";
import {UserService} from "../user/user.service";

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsLoaderService {

  GOOGLE_MAPS_API_KEY_PROPERTY = "google.api.maps.key";
  GOOGLE_MAPS_API_VERSION_PROPERTY = "google.api.maps.version";
  GOOGLE_MAPS_API_LIBRARIES_PROPERTY = "google.api.maps.libraries";

  mapsApiLoaded$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(private userService: UserService) { }

  async load() {
    const key = this.userService.getProperty(this.GOOGLE_MAPS_API_KEY_PROPERTY, "");
    const version = this.userService.getProperty(this.GOOGLE_MAPS_API_VERSION_PROPERTY, "weekly");
    const libraries = this.userService.getProperty(this.GOOGLE_MAPS_API_LIBRARIES_PROPERTY, "geometry,visualization,places").replace(" ", "").split(",");

    const loader = new Loader({
      apiKey: key,
      version: version,
      libraries: libraries as Libraries
    });

      try {
        await loader.load();
        if (loader.status == LoaderStatus.SUCCESS) {
          this.mapsApiLoaded$.next(true);
          return true;
        } else {
          return false;
        }
      } catch (e) {
        console.error("GoogleMapsLoaderService.load", e);
        return false;
      }
    }
}
